(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("formol", [], factory);
	else if(typeof exports === 'object')
		exports["formol"] = factory();
	else
		root["formol"] = factory();
})(this, () => {
return 